import { authLogin, authRegister, authLogout } from '@/shared/api/generated/auth/auth';
import { unwrap } from '@/shared/api/unwrap';

import { clearSession, setSession } from './session';

/**
 * Вход по адресу почты и паролю.
 *
 * Ошибку не глотает: форма показывает её человеку сама. Здесь только то, что
 * должно случиться при успехе.
 */
export async function signIn(email: string, password: string): Promise<void> {
  const session = unwrap(await authLogin({ email, password }));

  setSession(session.access_token, session.user);
}

/** Регистрация: учётная запись заводится и человек сразу входит. */
export async function signUp(email: string, name: string, password: string): Promise<void> {
  const session = unwrap(await authRegister({ email, name, password }));

  setSession(session.access_token, session.user);
}

/**
 * Выход.
 *
 * Сеанс на клиенте гасится в любом случае, даже если запрос не дошёл. Иначе
 * человек, нажавший «Выйти» на чужом компьютере при отвалившейся сети,
 * остался бы в системе — а это ровно тот случай, ради которого выход и
 * нажимают. Серверный сеанс при этом всё равно кончится по сроку.
 */
export async function signOut(): Promise<void> {
  try {
    await authLogout();
  } finally {
    clearSession();
  }
}
